import { Dialog as MuiDialog, styled } from '@mui/material';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const StyledDialog = styled(MuiDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    maxWidth: '870px',
    width: '100%',
    margin: '16px',
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  },
}));

const Dialog: React.FC<DialogProps> = ({ open, onClose, children }) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      {children}
    </StyledDialog>
  );
};

export default Dialog;
